import React from 'react';
import { Brands } from '../../../models/brands';
import { BrandStyling } from '../../../theme/brandStyling';

type AppCheckboxProps = {
    className?: string;
    label?: string;
    value: boolean;
    branding?: Brands; 
    setValue: (value: boolean) => void;
};

const AppCheckbox: React.FC<AppCheckboxProps> = ({
    label,
    value,
    branding = Brands.URocked,
    setValue,
}) => {
    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        setValue(e.currentTarget.checked);
    };

    return (
        <div className="flex justify-center">
            <div className="form-check form-switch">
                <input
                    className={`w-5 h-5 rounded form-tick appearance-none bg-surface border-2 
                    checked:border-0 focus:outline-none cursor-pointer
                    checked:focus:ring-0 ${BrandStyling.byBrand(branding).checkbox}`}
                    type="checkbox"
                    onChange={handleChange}
                    defaultChecked={value}
                />
                {label && (
                    <label
                        className="form-check-label inline-block text-gray-800"
                        htmlFor="flexSwitchCheckChecked"
                    >
                        Checked
                        {label}
                    </label>
                )}
            </div>
        </div>
    );
};

export default AppCheckbox;
